import { render, staticRenderFns } from "./HumanClicks.vue?vue&type=template&id=8b748224&scoped=true"
import script from "./HumanClicks.vue?vue&type=script&lang=js"
export * from "./HumanClicks.vue?vue&type=script&lang=js"
import style0 from "./HumanClicks.vue?vue&type=style&index=0&id=8b748224&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b748224",
  null
  
)

export default component.exports